<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>
